@if (isLoading) {
	<mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
}
@else {
	<div class="flex-column gap-32">
		<app-card preCardTitle="Group Management">
			@if (!isCartegraphEnabled) {
				<div *appCardContent class="settings-header-container mb-8">
					<div class="settings-header-title">
						<p>Add a new vehicle group</p>
						<div class="settings-header-subtitle">Create new Vehicle Group and update its settings.</div>
					</div>
					<div class="settings-header-actions">
						<button mat-stroked-button (click)="showAddNewVehicleGroupDialog()">Add Vehicle Group</button>
					</div>
				</div>
			}
			<div *appCardContent [ngClass]="{'mt-8':!isCartegraphEnabled}">
				<div class="settings-header-container">
					<div class="settings-header-title">
						Bulk import
						<div>Import multiple vehicles at one time</div>
					</div>
					<div class="settings-header-actions">
						<button mat-stroked-button
								(click)="importVehicles()">
							Import
						</button>
					</div>
				</div>
			</div>
		</app-card>
		<app-card preCardTitle="Vehicle Groups">
			<div *appCardContentRaw>
				<mat-nav-list class="raw-card-list">
					<mat-menu #menuGroup="matMenu">
						<ng-template matMenuContent let-group="group">
							<button mat-menu-item [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES, 'group', group.id]">
								Open
							</button>
							@if (!isCartegraphEnabled) {
								<button mat-menu-item (click)="changeGroupName(group)">
									Rename
								</button>
								<button mat-menu-item (click)="deleteGroup(group)">
									Remove
								</button>
							}
						</ng-template>
					</mat-menu>

					@for (group of vehicleGroups; track group.id) {
						<mat-list-item [routerLink]="['/', RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES, 'group', group.id]">
							<a matListItemTitle>{{ group.name }}</a>
							<div matListItemMeta>
								<button mat-icon-button
										(click)="$event.stopPropagation()"
										[matMenuTriggerFor]="menuGroup"
										[matMenuTriggerData]="{group:group}"
										aria-label="Menu">
									<mat-icon>more_vert</mat-icon>
								</button>
							</div>
						</mat-list-item>
						@if (!$last) {
							<mat-divider></mat-divider>
						}
					}
				</mat-nav-list>
			</div>
		</app-card>
	</div>
}
